const script = () => {
    window.planity = {
        key: '59--ba3',
        primaryColor: '$neutralDark',
        container: document.querySelector('#planity .wrap-resp') // any DOM node reference
    };
};

exports.script = script;